/* Search popup: replaces the "Popular products" chips with the store's current
   best-sellers when the search opens (snippets/header-search.liquid).
   The Liquid-rendered chips stay as the fallback if the request fails. */
(function () {
  if (window.skdgSearchPopularInit) return;
  window.skdgSearchPopularInit = true;

  const cache = {};

  const load = (list) => {
    const url = list.dataset.skdgPopularUrl;
    const limit = parseInt(list.dataset.limit, 10) || 6;
    if (!url || list.dataset.loaded) return;
    list.dataset.loaded = 'true';

    cache[url] =
      cache[url] ||
      fetch(url, { headers: { Accept: 'text/html' } }).then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      });

    cache[url]
      .then((html) => {
        const template = document.createElement('template');
        template.innerHTML = html.trim();
        const items = Array.from(template.content.querySelectorAll('li')).slice(0, limit);
        if (items.length) list.replaceChildren(...items);
      })
      .catch(() => {
        delete list.dataset.loaded;
      });
  };

  document.querySelectorAll('[data-skdg-popular-url]').forEach((list) => {
    const details = list.closest('details');
    if (!details) return load(list);
    if (details.open) load(list);
    details.addEventListener('toggle', () => {
      if (details.open) load(list);
    });
  });
})();
